import React, { useState, useEffect, useReducer, useRef } from 'react';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';

import SVG from 'react-inlinesvg';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Select } from '../../../../../../../_metronic/_partials/controls';
import { toAbsoluteUrl } from '../../../../../../../_metronic/_helpers';

import Numeric from '../../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../../redux/my-axios';
import { initialOrder, orderStatusList } from '../../OrdersUIHelpers';

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        orderCode: action.payload.orderCode,
        orderDate: action.payload.orderDate,
        websiteCode: action.payload.websiteCode,
        purchaseOrderId: action.payload.purchaseOrderId,
        cargoCode: action.payload.cargoCode,
        status: action.payload.status,
        subTotalAmount: parseFloat(action.payload.subTotalAmount),
        totalTaxAmount: parseFloat(action.payload.totalTaxAmount),
        shippingAmount: parseFloat(action.payload.shippingAmount),
        totalAmount: parseFloat(action.payload.totalAmount),
        rewardAmount: parseFloat(action.payload.rewardAmount),
        cardChargeAmount: parseFloat(action.payload.cardChargeAmount),
      };
    case 'setOrderCode':
      return { ...state, orderCode: action.payload };
    case 'setOrderDate':
      return { ...state, orderDate: action.payload };
    case 'setWebsiteCode':
      return { ...state, websiteCode: action.payload };
    case 'setPurchaseOrderId':
      return { ...state, purchaseOrderId: action.payload };
    case 'setCargoCode':
      return { ...state, cargoCode: action.payload };
    case 'setSubTotalAmount':
      return {
        ...state,
        subTotalAmount: action.payload,
      };
    case 'setTotalTaxAmount':
      return {
        ...state,
        totalTaxAmount: action.payload,
      };
    case 'setShippingAmount':
      return {
        ...state,
        shippingAmount: action.payload,
      };
    case 'setTotalAmount':
      return { ...state, totalAmount: action.payload };
    case 'setRewardAmount':
      return {
        ...state,
        rewardAmount: action.payload,
      };
    case 'setCardChargeAmount':
      return { ...state, cardChargeAmount: action.payload };
    case 'calcTotalAmount':
      return {
        ...state,
        totalAmount:
          state.subTotalAmount + state.totalTaxAmount + state.shippingAmount,
      };
    case 'calcCardChargeAmount':
      return {
        ...state,
        cardChargeAmount: state.totalAmount - state.rewardAmount,
      };
    default:
      throw new Error();
  }
}

const PARAM_URL = '/params';

const OrderMain = (props) => {
  const {
    intl,
    actionsLoading,
    msg,
    dialogError,
    orderForView,
    initialOrder,
    btnRefSave,
    newClick,
    btnRefNew,
    saveOrder,
    onHide,
  } = props;

  //console.log('OrderViewForm', orderForView);
  const [state, dispatch] = useReducer(reducer, initialOrder);
  const [err, setErr] = useState('');
  // States
  const [websiteList, setWebsiteList] = useState([]);
  const [cargoList, setCargoList] = useState([]);
  const [loaded, setLoaded] = useState(false);

  // Messages
  const AUTH_VALIDATION_MIN_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MIN_LENGTH',
  });
  const AUTH_VALIDATION_MAX_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MAX_LENGTH',
  });
  const AUTH_VALIDATION_MIN_VALUE = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MIN_VALUE',
  });
  const AUTH_VALIDATION_MAX_VALUE = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MAX_VALUE',
  });
  const AUTH_VALIDATION_REQUIRED = intl.formatMessage({
    id: 'GENERAL.VALIDATION.REQUIRED',
  });
  const OrderCreateSchema = Yup.object().shape({
    orderDate: Yup.string().required(AUTH_VALIDATION_REQUIRED),
    websiteCode: Yup.string().required(AUTH_VALIDATION_REQUIRED),
    purchaseOrderId: Yup.string()
      .min(1, AUTH_VALIDATION_MIN_LENGTH.replace('#value#', '1'))
      .max(128, AUTH_VALIDATION_MAX_LENGTH.replace('#value#', '100'))
      .required(AUTH_VALIDATION_REQUIRED),
    totalAmount: Yup.number()
      .required(AUTH_VALIDATION_REQUIRED)
      .min(1, AUTH_VALIDATION_MIN_LENGTH.replace('#value#', '1'))
      .typeError('тоон дүн оруулна уу'),
    subTotalAmount: Yup.string().required(AUTH_VALIDATION_REQUIRED),
  });

  useEffect(() => {
    dispatch({ type: 'init', payload: orderForView });
  }, [orderForView]);

  useEffect(() => {
    console.log('ORDER: ', state);
  }, [state]);
  useEffect(() => {
    const storeKeyWebsite = 'websiteList';
    let listWebsite = undefined;
    if (websiteList !== []) {
      listWebsite = localStorage.getItem(storeKeyWebsite);
      if (listWebsite) {
        setWebsiteList(JSON.parse(listWebsite));
      } else {
        axios
          .post(PARAM_URL, 'getwebsitelist', {
            headers: { action: 'getwebsitelist' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                setWebsiteList(response.data.data);
                localStorage.setItem(
                  storeKeyWebsite,
                  JSON.stringify(response.data.data)
                );
                break;
              default:
                break;
            }
          })
          .catch((error) => {});
      }
    } else {
      listWebsite = localStorage.getItem(storeKeyWebsite);
      if (!listWebsite) {
        localStorage.setItem(storeKeyWebsite, JSON.stringify(websiteList));
      }
      setLoaded(true);
    }

    const storeKeyCargo = 'cargoList';
    let listCargo = undefined;
    if (cargoList !== []) {
      listCargo = localStorage.getItem(storeKeyCargo);
      if (listCargo) setCargoList(JSON.parse(listCargo));
      else
        axios
          .post(PARAM_URL, 'getcargolist', {
            headers: { action: 'getcargolist' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                setCargoList(response.data.data);
                localStorage.setItem(
                  storeKeyCargo,
                  JSON.stringify(response.data.data)
                );
                break;
              default:
                break;
            }
          })
          .catch((error) => {});
    } else {
      listCargo = localStorage.getItem(storeKeyCargo);
      if (!listCargo)
        localStorage.setItem(storeKeyCargo, JSON.stringify(cargoList));
      setLoaded(true);
    }

    return function cleanup() {
      setWebsiteList([]);
      setCargoList([]);
    };
  }, [loaded]);

  useEffect(() => {
    setErr(dialogError);
  }, [dialogError]);

  const save = (values) => {
    //console.log('Save:', values);
    saveOrder(values);
  };

  const create = () => {
    // eniig shalgaltiig talbar burrer ni tulgaj saijruulna
    //console.log('Compare: ', orderForView, state);
    if (
      !msg &
      (orderForView.websiteCode != state.websiteCode ||
        orderForView.purchaseOrderId != state.purchaseOrderId ||
        orderForView.subTotalAmount != state.subTotalAmount ||
        orderForView.shippingAmount != state.shippingAmount ||
        orderForView.totalTaxAmount != state.totalTaxAmount ||
        orderForView.totalAmount != state.totalAmount ||
        orderForView.rewardAmount != state.rewardAmount ||
        orderForView.cardChargeAmount != state.cardChargeAmount)
    ) {
      setErr('Өөрчлөлтөө хадгална уу!');
    } else {
      setErr('');
      newClick();
    }
  };

  const setSubTotalAmount = (subTotalAmount) => {
    dispatch({
      type: 'setSubTotalAmount',
      payload: parseFloat(subTotalAmount),
    });
    dispatch({ type: 'calcTotalAmount', payload: '' });
    dispatch({ type: 'calcCardChargeAmount', payload: '' });
  };
  const setShippingAmount = (shippingAmount) => {
    dispatch({
      type: 'setShippingAmount',
      payload: parseFloat(shippingAmount),
    });
    dispatch({ type: 'calcTotalAmount', payload: '' });
    dispatch({ type: 'calcCardChargeAmount', payload: '' });
  };
  function setTotalTaxAmount(totalTaxAmount) {
    dispatch({
      type: 'setTotalTaxAmount',
      payload: parseFloat(totalTaxAmount),
    });
    dispatch({ type: 'calcTotalAmount', payload: '' });
    dispatch({ type: 'calcCardChargeAmount', payload: '' });
  }
  const setTotalAmount = (totalAmount) => {
    dispatch({ type: 'setTotalAmount', payload: parseFloat(totalAmount) });
    dispatch({ type: 'calcCardChargeAmount', payload: '' });
  };
  const setRewardAmount = (rewardAmount) => {
    dispatch({ type: 'setRewardAmount', payload: parseFloat(rewardAmount) });
    dispatch({ type: 'calcCardChargeAmount', payload: '' });
  };
  const setCardChargeAmount = (cardChargeAmount) => {
    dispatch({
      type: 'setCardChargeAmount',
      payload: parseFloat(cardChargeAmount),
    });
  };
  const setWebsiteCode = (websiteCode) => {
    dispatch({ type: 'setWebsiteCode', payload: websiteCode });
  };
  const setPurchaseOrderId = (purchaseOrderId) => {
    dispatch({ type: 'setPurchaseOrderId', payload: purchaseOrderId });
  };
  const setOrderDate = (orderDate) => {
    dispatch({ type: 'setOrderDate', payload: orderDate });
  };
  const setCargoCode = (cargoCode) => {
    dispatch({ type: 'setCargoCode', payload: cargoCode });
  };
  const setStatus = (status) => {
    dispatch({ type: 'setStatus', payload: status });
  };
  const calcTotalAmount = () => {
    dispatch({ type: 'calcTotalAmount', payload: '' });
  };

  const handleChange = (event) => {
    setOrderDate(event.target.value);
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={state}
        validationSchema={OrderCreateSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({ errors, touched, handleBlur, isValidating }) => (
          <>
            <Form className='form form-label-right' size='sm'>
              {err ? (
                <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{err}</div>
                </div>
              ) : (
                <div></div>
              )}
              {msg ? (
                <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{msg}</div>
                </div>
              ) : (
                <div></div>
              )}
              <div className='form-group row'>
                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.ORDERDATE' />
                  </label>
                  <input
                    id='orderDate'
                    type='date'
                    className='form-control form-control-sm'
                    value={state.orderDate}
                    onChange={handleChange}
                    disabled={state.orderCode}
                  />
                  {errors.orderDate && touched.orderDate ? (
                    <div>{errors.orderDate}</div>
                  ) : null}
                </div>
                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.WEBSITE' />
                  </label>
                  <Select
                    name='websiteCode'
                    className='form-control form-control-sm'
                    onChange={(e) => {
                      setWebsiteCode(e.target.value);
                    }}
                  >
                    {websiteList.map((option) => (
                      <option
                        key={`websiteList${option.code}`}
                        value={option.code}
                      >
                        {option.name}
                      </option>
                    ))}
                  </Select>
                  {errors.websiteCode && touched.websiteCode ? (
                    <div>{errors.websiteCode}</div>
                  ) : null}
                </div>
                <div className='col-4'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.PURCHASEORDERID' />
                  </label>
                  <Field
                    name='purchaseOrderId'
                    className='form-control form-control-sm'
                    onChange={(e) => {
                      setPurchaseOrderId(e.target.value);
                    }}
                  />
                  {errors.purchaseOrderId && touched.purchaseOrderId ? (
                    <div>{errors.purchaseOrderId}</div>
                  ) : null}
                </div>
                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.CARGO' />
                  </label>
                  <Select
                    name='cargoCode'
                    className='form-control form-control-sm'
                    onChange={(e) => {
                      setCargoCode(e.target.value);
                    }}
                  >
                    {cargoList.map((option) => (
                      <option
                        key={`cargoList${option.code}`}
                        value={option.code}
                      >
                        {option.name}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.STATUS' />
                  </label>
                  <Select
                    name='status'
                    className='form-control form-control-sm'
                    onChange={(e) => {
                      setStatus(e.target.value);
                    }}
                    disabled={state.orderCode}
                  >
                    {orderStatusList.map((option) => (
                      <option
                        key={`orderStatusList${option.key}`}
                        value={option.key}
                      >
                        {option.value}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.SUBTOTALAMOUNT' />
                  </label>
                  <Numeric
                    name='subTotalAmount'
                    value={state.subTotalAmount}
                    onChange={setSubTotalAmount}
                    className='form-control form-control-sm'
                  />
                  {errors.subTotalAmount && touched.subTotalAmount ? (
                    <div>{errors.subTotalAmount}</div>
                  ) : null}
                </div>
                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.TAXAMOUNT' />
                  </label>
                  <Numeric
                    name='totalTaxAmount'
                    value={state.totalTaxAmount}
                    onChange={setTotalTaxAmount}
                    className='form-control form-control-sm'
                  />
                  {errors.totalTaxAmount && touched.totalTaxAmount ? (
                    <div>{errors.totalTaxAmount}</div>
                  ) : null}
                </div>
                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.SHIPPINGAMOUNT' />
                  </label>
                  <Numeric
                    name='shippingAmount'
                    value={state.shippingAmount}
                    className='form-control form-control-sm'
                    onChange={setShippingAmount}
                  />
                </div>
                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.TOTALAMOUNT' />
                  </label>
                  <Numeric
                    name='totalAmount'
                    value={state.totalAmount}
                    className='form-control form-control-sm'
                    onChange={setTotalAmount}
                  />
                  {errors.totalAmount && touched.totalAmount ? (
                    <div>{errors.totalAmount}</div>
                  ) : null}
                  {/* <button
                      id='calcTotalAmount'
                      type='button'
                      title='Нийт дүнг тооцоолох'
                      className='btn btn-icon btn-light btn-hover-primary btn mx-3'
                      onClick={calcTotalAmount({
                        a: order.subTotalAmount,
                        b: order.totalTaxAmount,
                        c: order.shippingAmount,
                      })}
                    >
                      <span className='svg-icon svg-icon-md svg-icon-primary'>
                        <SVG
                          src={toAbsoluteUrl(
                            '/media/svg/icons/General/Update.svg'
                          )}
                        />
                      </span>
                    </button>*/}
                </div>

                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.REWARDAMOUNT' />
                  </label>
                  <Numeric
                    name='rewardAmount'
                    value={state.rewardAmount}
                    className='form-control form-control-sm'
                    onChange={setRewardAmount}
                  />
                </div>
                <div className='col-2'>
                  <label>
                    <FormattedMessage id='ORDER.LABEL.CARDCHARGEAMOUNT' />
                  </label>
                  <Numeric
                    name='cardChargeAmount'
                    value={state.cardChargeAmount}
                    className='form-control form-control-sm'
                    onChange={setCardChargeAmount}
                    disabled={state.orderCode}
                  />
                </div>
              </div>
              <button
                type='submit'
                style={{ display: 'none' }}
                ref={btnRefSave}
              ></button>
              <button
                type='button'
                style={{ display: 'none' }}
                ref={btnRefNew}
                onClick={() => create()}
              ></button>
              <button
                type='button'
                onClick={onHide}
                style={{ display: 'none' }}
              >
                cancel
              </button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default injectIntl(OrderMain);
